import React from 'react';
import { Box } from '@mui/material';

/** Zeilenhöhe von TYPO.navLink — Ausrichtung mit „Menü“-Label */
export const MENU_TOGGLE_LINE_HEIGHT = '22.68px';

interface BurgerButtonProps {
  open: boolean;
  onClick: () => void;
  color: string;
  'aria-label'?: string;
}

/** Figma hamburger.svg (13×9): stroke centers y=0.5 & y=8.5 → skaliert auf 12px Höhe */
const ICON_W = 18;
const ICON_H = 12;
const LINE_H = 1.5;
const LINE_Y_CLOSED = [1, 9.5] as const;
const LINE_Y_CENTER = (ICON_H - LINE_H) / 2;

const BurgerButton: React.FC<BurgerButtonProps> = ({
  open,
  onClick,
  color,
  'aria-label': ariaLabel,
}) => (
  <Box
    component="button"
    type="button"
    aria-label={ariaLabel ?? (open ? 'Menü schließen' : 'Menü öffnen')}
    aria-expanded={open}
    onClick={onClick}
    sx={{
      width: MENU_TOGGLE_LINE_HEIGHT,
      height: MENU_TOGGLE_LINE_HEIGHT,
      p: 0,
      border: 'none',
      background: 'transparent',
      cursor: 'pointer',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      verticalAlign: 'middle',
      overflow: 'visible',
    }}
  >
    <Box
      sx={{
        position: 'relative',
        width: ICON_W,
        height: ICON_H,
        overflow: 'visible',
      }}
    >
      {LINE_Y_CLOSED.map((top, index) => (
        <Box
          key={index}
          sx={{
            position: 'absolute',
            left: 0,
            right: 0,
            height: `${LINE_H}px`,
            backgroundColor: color,
            borderRadius: `${LINE_H / 2}px`,
            top: `${top}px`,
            transition: 'transform 0.35s ease, top 0.35s ease',
            transformOrigin: 'center',
            transform: open
              ? `translateY(${LINE_Y_CENTER - top}px) rotate(${index === 0 ? 45 : -45}deg)`
              : 'none',
          }}
        />
      ))}
    </Box>
  </Box>
);

export default BurgerButton;
